module.exports = __webpack_public_path__ + "img/settings-10.f2bb2b3a.svg";